// Generic immutable helpers for "list of rows + add/remove" form fields
// (e.g. Email Subjects, Send Conditions). Callers supply the row shape via
// makeEmpty / updater / isComplete.

export function addRow(items, makeEmpty) {
  return [...(items ?? []), makeEmpty()];
}

export function removeRowAt(items, index, makeEmpty) {
  const current = items ?? [];
  if (current.length <= 1) return current;
  const next = current.filter((_, i) => i !== index);
  return next.length ? next : [makeEmpty()];
}

export function setRowAt(items, index, updater) {
  const next = [...(items ?? [])];
  if (next[index] == null) return next;
  next[index] = updater(next[index]);
  return next;
}

export function canAddRow(items, isComplete) {
  const list = items ?? [];
  const last = list[list.length - 1];
  return Boolean(last != null && isComplete(last));
}
